
// SVG Icon: dataCatalog
export default { id: "terriajs-dataCatalog" };
export const id = "terriajs-dataCatalog";
export const name = "dataCatalog";
